import userAuthReducer from './auth/reducers'
import exercisesReducer from './exercises/reducers'
import messageHandler from './messageHandler/reducers'
import { addPatientReducer, patientsReducer } from './patients/reducers'
import { assignScheduleReducer, schedulesReducer } from './schedules/reducers'
import {
  addScheduleTemplateReducer,
  scheduleTemplatesReducer
} from './scheduleTemplates/reducers'
import userReducer from './user/reducers'

const reducers = {
  auth: userAuthReducer,
  messages: messageHandler,
  user: userReducer,
  patients: patientsReducer,
  addPatient: addPatientReducer,
  exercises: exercisesReducer,
  schedules: schedulesReducer,
  assignSchedule: assignScheduleReducer,
  scheduleTemplates: scheduleTemplatesReducer,
  addScheduleTemplate: addScheduleTemplateReducer
}

export default reducers
